import React, { useState } from "react";
import { CInput } from "@coreui/react";
import {
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CCol,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { FormGroup } from "@material-ui/core";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";

// import { FaEye, FaEyeSlash } from "react-icons/fa";

export const renderInput = ({
  input,
  type,
  autoComplete,
  value,
  placeholder,
  className,
  labelStyle,
  labelName,
  name,
  step,
  min,
  disabled,
  labelClass,
  meta: { touched, error },
}) => {
  return (
    <>
      <div className="form-group" style={{ textAlign: labelStyle }}>
        <label htmlFor="text-input">{labelName}</label>
        <CInput
          disabled={disabled}
          value={value}
          {...input}
          step={step}
          min={min}
          autoComplete={autoComplete}
          className={className}
          name={name}
          placeholder={placeholder}
          type={type}
        />
        {touched && error && (
          <div style={{ textAlign: "right" }}>
            <span style={{ color: "#007fb2" }}>{error}</span>
          </div>
        )}
      </div>
    </>
  );
};
export const renderDiscount = ({
  input,
  type,
  autoComplete,
  value,
  placeholder,
  className,
  labelStyle,
  labelName,
  name,
  step,
  min,
  disable,
  max,
  meta: { touched, error },
}) => {
  return (
    <>
      <div className="py-2 form-group" style={{ textAlign: labelStyle }}>
        <label htmlFor="text-input">{labelName}</label>
        <CInput
          disabled={disable}
          value={value}
          {...input}
          step={step}
          min={min}
          max={max}
          autoComplete={autoComplete}
          className={className}
          name={name}
          placeholder={placeholder}
          type={type}
        />
        {touched && error && (
          <div>
            <span style={{ color: "red", textAlign: "right" }}>{error}</span>
          </div>
        )}
      </div>
    </>
  );
};

export const renderTextArea = ({
  input,
  name,
  className,
  labelName,
  labelStyle,
  meta: { touched, error },
}) => {
  return (
    <>
      <div className="form-group" style={{ textAlign: labelStyle }}>
        <label className="bold" htmlFor="gameDescription">
          {labelName}
        </label>
        <textarea {...input} rows="5" name={name} className={className} />
        {touched && error && (
          <div style={{ textAlign: "right" }}>
            <span style={{ color: "#007fb2" }}>{error}</span>
          </div>
        )}
      </div>
    </>
  );
};
export const renderDateNTime = ({
  input,
  type,
  className,
  name,
  meta: { touched, error },
}) => {
  return (
    <>
      <input {...input} type={type} name={name} className={className} />
      {touched && error && (
        <h6 style={{ textAlign: "right", color: "red" }}>{error}</h6>
      )}
    </>
  );
};

export const renderFile = ({
  input: { onChange },
  name,
  type,
  disabled,
  accept,
  meta: { touched, error },
}) => {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    onChange(file); // Pass the file to Redux Form
  };

  return (
    <>
      <input
        name={name}
        type={type}
        accept={accept}
        onChange={handleFileChange}
        disabled={disabled}
      />
      {touched && error && (
        <div style={{ textAlign: "left" }}>
          <span style={{ color: "#007fb2" }}>{error}</span>
        </div>
      )}
    </>
  );
};

export const renderFileField = ({
  input,
  profilePic,
  label,
  type,
  meta: { touched, error, warning },
}) => {
  return (
    <FormGroup row>
      <CCol md="3">
        <label htmlFor="text-input">{label}</label>
      </CCol>
      <CCol xs="12" md="6">
        {profilePic.src && (
          <figure>
            <img
              src={profilePic.src}
              alt={profilePic.alt}
              height="80px"
              width="80px"
            />
          </figure>
        )}
        <CInput
          {...input}
          multiple
          type={type}
          accept="image/jpeg,image/png,image/jpg"
          value={undefined}
        />
        <div className="text-danger">
          {touched &&
            ((error && <span>{error}</span>) ||
              (warning && <span>{warning}</span>))}
        </div>
      </CCol>
    </FormGroup>
  );
};

export const renderDropDown = ({
  input,
  name,
  className,
  listItem,
  meta: { touched, error },
}) => {
  return (
    <>
      <select {...input} name={name} className={className}>
        {listItem.map((val, index) => {
          return (
            <option key={index} value={val}>
              {val}
            </option>
          );
        })}
      </select>
      {touched && error && (
        <div style={{ textAlign: "right" }}>
          <span style={{ color: "red", textAlign: "right" }}>{error}</span>
        </div>
      )}
    </>
  );
};

export const RenderSelectInput = ({
  input,
  label,
  options,
  name,
  ss,
  meta: { touched, error },
}) => (
  <>
    <div className="form-group">
      <label>{label}</label>
      <Select
        defaultValue={ss}
        isMulti
        name={name}
        options={options}
        value={input.value}
        closeMenuOnSelect={false}
        onChange={(value) => input.onChange(value)}
      />
      {touched && error && (
        <div style={{ textAlign: "right" }}>
          <span style={{ color: "red", textAlign: "right" }}>{error}</span>
        </div>
      )}
    </div>
  </>
);
export const RenderSelectInputSingle = ({
  input,
  label,
  options,
  name,
  meta: { touched, error },
}) => (
  <>
    <div className="form-group">
      <label>{label}</label>
      <Select
        name={name}
        options={options}
        value={input.value}
        onChange={(value) => input.onChange(value)}
        isClearable={true}
      />
      {touched && error && (
        <div style={{ textAlign: "right" }}>
          <span style={{ color: "#007fb2", textAlign: "right" }}>{error}</span>
        </div>
      )}
    </div>
  </>
);
export const renderSmallInput = ({
  input,
  placeholder,
  cicon,
  name,
  autoComplete,
  type,
  meta: { touched, error, warning },
}) => {
  return (
    <div className="mb-3">
      <CInputGroup>
        <CInputGroupPrepend>
          {cicon && (
            <CInputGroupText>
              <CIcon name={cicon} />
            </CInputGroupText>
          )}
        </CInputGroupPrepend>
        <CInput
          {...input}
          type={type}
          name={name}
          placeholder={placeholder}
          autoComplete={autoComplete}
        />
      </CInputGroup>
      {touched && error && (
        <div style={{ textAlign: "right" }}>
          <span style={{ color: "#007fb2" }}>{error}</span>
        </div>
      )}
    </div>
  );
};

// export const renderPasswordInput = ({
//   input,
//   placeholder,
//   name,
//   labelName,
//   meta: { touched, error },
// }) => {
//   // const [showPassword, setShowPassword] = useState(false);

//   return (
//     <div className="form-group">
//       {labelName && <label htmlFor={name}>{labelName}</label>}
//       <CInputGroup>
//         <CInputGroupPrepend>
//           <CInputGroupText>
//             <span role="img" aria-label="lock">
//               🔒
//             </span>
//           </CInputGroupText>
//         </CInputGroupPrepend>

//         <CInput
//           {...input}
//           type="password"
//           name={name}
//           placeholder={placeholder}
//         />

//         {/* <CInputGroupPrepend> */}
//         {/* <CInputGroupText style={{ cursor: "pointer" }}> */}
//         {/* {showPassword ? <FaEyeSlash /> : <FaEye />} */}
//         {/* </CInputGroupText> */}
//         {/* </CInputGroupPrepend> */}
//       </CInputGroup>

//       {/* {touched && error && (
//         <div className="text-right">
//           <span style={{ color: "red" }}>{error}</span>
//         </div>
//       )} */}
//     </div>
//   );
// };
export const renderPasswordInput = ({
  input,
  placeholder,
  name,
  labelName,
  className,
  meta: { touched, error },
}) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{labelName}</label>
      <input
        {...input}
        type="password"
        name={name}
        className={className}
        placeholder={placeholder}
        autoComplete="new-password"
      />
      {touched && error && (
        <div className="text-danger text-right">
          <small>{error}</small>
        </div>
      )}
    </div>
  );
};

export const forgotPassword = ({
  input,
  type,
  name,
  meta: { touched, error },
}) => {
  return (
    <>
      <CInputGroup className="pt-4">
        <CInputGroupPrepend>
          <CInputGroupText>@</CInputGroupText>
        </CInputGroupPrepend>
        <CInput
          {...input}
          className="form-control pb-1"
          name={name}
          type={type}
          placeholder="Email"
        />
      </CInputGroup>
      <div className="text-right">
        {touched && error && <h6 style={{ color: "red" }}>{error}</h6>}
      </div>
    </>
  );
};
// export const resetPasswordInput = ({ input, type, name, placeholder, meta: { error, touched } }) => {
//   return (<>
//     <input
//       {...input}
//       className="mt-4 form-control pb-1"
//       name={name}
//       type={type}
//       placeholder={placeholder}
//     />
//     <div className="text-right">{(touched && error) && <h6 style={{ color: 'red' }}>{error}</h6>}</div>
//   </>)
// }

export const renderEditor = ({ input }) => {
  return (
    <CKEditor
      data={input.value}
      editor={ClassicEditor}
      onChange={(event, editor) => {
        return input.onChange(editor.getData());
      }}
    />
  );
};

export const renderSymbolInput = ({
  input,
  placeholder,
  labelName,
  cicon,
  name,
  autoComplete,
  type,
  meta: { touched, error, warning },
}) => {
  return (
    <>
      <label className="bold" htmlFor="gameDescription">
        {labelName}
      </label>

      <CInputGroup className="mb-3">
        <CInput
          {...input}
          type={type}
          name={name}
          placeholder={placeholder}
          autoComplete={autoComplete}
        />
        <CInputGroupPrepend>
          <CInputGroupText>
            <CIcon name={cicon} />
          </CInputGroupText>
        </CInputGroupPrepend>
        <div className="col-md-12 text-right">
          {touched && error && <h6 style={{ color: "red" }}>{error}</h6>}
        </div>
      </CInputGroup>
    </>
  );
};

// export const InputCheck = ({
//   input,
//   label,
//   type,
//   icon,
//   isChecked,
//   value,
//   name,
//   idFor,
//   isDisabled,
//   fieldClassName,
//   meta: { touched, error, warning },
// }) => (
//   <>
//     <div className={`d-flex ${fieldClassName ? fieldClassName : ''}`}>
//       <div className='mr-2'>
//         <input
//           {...input}
//           name={name}
//           id={idFor}
//           type={type}
//           value={value}
//           defaultChecked={isChecked && (isChecked === value ? true : false)}
//         />
//       </div>
//       <label htmlFor={idFor}>{label}</label>
//       <div className="col-md-12 text-right">
//         {(touched && error) && <h6 style={{ color: 'red' }}>{error}</h6>}
//       </div>
//     </div>

//   </>
// );

export const RadioButton = ({
  input,
  forId,
  isChecked,
  onChange,
  defaultChecked,
  radioButtonValue,
  placeholder,
  label,
  name,
  type,
  meta: { touched, error, warning },
}) => {
  return (
    <>
      <label className="round-box" htmlFor={forId}>
        {label}
        <input
          name={name}
          defaultChecked={
            isChecked && (isChecked === radioButtonValue ? true : false)
          }
          type="radio"
          {...input}
          id={forId}
          value={radioButtonValue}
        />
        <span className="checkmark"></span>
      </label>
    </>
  );
};

// export const InputCheck1 = ({input,type,name,label,value,fieldClassName}) => (
//   <>
//     <div className={`d-flex ${fieldClassName ? fieldClassName : ''}`}>
//       <input {...input} type={type} name={name} value={value} />
//       <label>{label}</label>

//     </div>

//   </>
// );
